import React, { useEffect, useState } from "react";
import { useGlobalSocket } from "@/context/GlobalSocket";
import { AnimatePresence, motion } from "framer-motion";
import { toast } from "sonner";

const KIND_BG = {
  info: "bg-white text-black",
  success: "bg-[color:var(--uno-green)] text-black",
  warn: "bg-[color:var(--uno-yellow)] text-black",
  party: "bg-gradient-to-r from-[color:var(--uno-red)] via-[color:var(--uno-yellow)] to-[color:var(--uno-blue)] text-black",
};

export default function BroadcastBanner() {
  const { broadcast, dismissBroadcast, lastGift } = useGlobalSocket();
  const [lastGiftShown, setLastGiftShown] = useState(0);

  // Show toast for coin gifts (personal or gift-all)
  useEffect(() => {
    if (!lastGift || lastGift.at === lastGiftShown) return;
    setLastGiftShown(lastGift.at);
    const label = lastGift.all
      ? `Everyone got +${lastGift.amount} coins!`
      : `${lastGift.from} gifted you ${lastGift.amount > 0 ? "+" : ""}${lastGift.amount} coins`;
    toast.success(label, { duration: 5000 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastGift]);

  return (
    <AnimatePresence>
      {broadcast && (
        <motion.div
          data-testid="broadcast-banner"
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 24 }}
          className="fixed top-0 inset-x-0 z-[60] flex justify-center pointer-events-none px-3 sm:px-6 pt-3"
        >
          <div className={`pointer-events-auto max-w-3xl w-full rounded-2xl shadow-lg px-4 sm:px-6 py-3 flex items-center gap-3 ${KIND_BG[broadcast.kind] || KIND_BG.info}`}>
            <span className="text-lg">{broadcast.kind === "party" ? "🎉" : broadcast.kind === "warn" ? "⚠️" : broadcast.kind === "success" ? "✅" : "📣"}</span>
            <div className="flex-1 min-w-0">
              <div className="text-[10px] uppercase tracking-widest opacity-70">Broadcast · from {broadcast.from}</div>
              <div className="font-display text-lg sm:text-xl leading-snug break-words">{broadcast.message}</div>
            </div>
            <button
              onClick={dismissBroadcast}
              className="text-black/60 hover:text-black text-lg font-bold px-2"
              aria-label="Dismiss"
            >×</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
